import React from 'react'

import clsx from 'clsx'

import classes from './ContentFootnote.module.scss'

const ContentFootnote = ({ title, children }) => {
  return (
    <div className={clsx('ContentFootnote', classes.root)}>
      <h4 className={classes.title}>{title}</h4>
      <div>{children}</div>
    </div>
  )
}

export default ContentFootnote
